module.exports = __webpack_public_path__ + "static/media/silver_pkg_icon.17761562.svg";